export const Sizes = [
  { title: "1000px" },
  { title: "750px" },
  { title: "640px" },
];
